import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import uniqid from 'uniqid'

import { setActionDetail } from 'redux/smartchat/details/actions'
import { setAlternatives, deleteAlternatives, setAlternativesActionDetail } from 'redux/smartchat/alternatives/actions'
import AlternativesViewUI from './AlternativesViewUI'

const AlternativesView = ({ renderType, label, previewActionRef, previewActionDetail, dataWay, error }) => {
  const dispatch = useDispatch()
  const [value, setValue] = useState(null)
  const [alternativesId, setAlternativesId] = useState('')
  const [isOpenAlternativesModal, setIsOpenAlternativesModal] = useState(false)

  // Aplica los valores actuales recibidos (Preview y Modal en modo edición)
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!previewActionDetail.eventData || !Object.keys(previewActionDetail.eventData).length) return

      setValue(prevState => ({
        ...prevState,
        ...previewActionDetail.eventData,
        level: getAlternativesLevel(previewActionDetail.eventData)
      }))
    }

    return () => isSubscribed = false
  }, [previewActionDetail])

  const toggleAlternativesModal = () => {
    if (!isOpenAlternativesModal) {
      const alternativesId = uniqid('alternatives-')
      setAlternativesId(alternativesId)

      if (dataWay) {
        dispatch(setAlternativesActionDetail({ alternativesId: dataWay.alternativesId, actionDetail: previewActionDetail }))
      } else {
        dispatch(setActionDetail(previewActionDetail))
      }

      dispatch(setAlternatives({ alternativesId, alternativesData: previewActionDetail.eventData }))
    } else {
      dispatch(deleteAlternatives({ alternativesId }))
      setAlternativesId('')
    }

    setIsOpenAlternativesModal(!isOpenAlternativesModal)
  }

  const getAlternativesLevel = (alternativesData) => {
    let alternativesLevel = []

    alternativesData.alternativeList.forEach(alternative => {
      let newProcess = 0
      let process = 0

      alternative.alternativeActions.onNewProcess.actionList.forEach(action => {
        if (action.eventType === 'showAlternatives') {
          newProcess = getAlternativesLevel(action.eventData)
        }
      })

      alternative.alternativeActions.onProcess[0].actionList.forEach(action => {
        action.botActionList.forEach(botAction => {
          if (botAction.eventType === 'showAlternatives') {
            process = getAlternativesLevel(botAction.eventData)
          }
        })
      })

      alternativesLevel.push(Math.max(newProcess, process) + 1)
    })

    return Math.max(...alternativesLevel)
  }

  return (
    <AlternativesViewUI
      id={uniqid()}
      renderType={renderType}
      label={label}
      value={value}
      alternativesId={alternativesId}
      fromAlternativesId={dataWay?.alternativesId}
      previewActionRef={previewActionRef}
      isOpenAlternativesModal={isOpenAlternativesModal}
      toggleAlternativesModal={toggleAlternativesModal}
      error={error}
    />
  )
}

export default AlternativesView
